import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from './toaster.service';
import { apiErrorHandler } from '../constants/api-error-handler';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  constructor(
    private router: Router,
    private toaster: ToasterService,
  ) {}

  handleResolverError(error: any) {
    apiErrorHandler.bind({ toaster: this.toaster })(error);
    if (!this.router.getCurrentNavigation()?.previousNavigation) {
      this.router.navigateByUrl('/404', {
        state: {
          errorMessage: error?.error?.message || error?.message,
        },
      });
    }
  }
}
